import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const joinWaitlist = (data) =>
  axios.post(`${API}/waitlist`, data).then((r) => r.data);

export const getWaitlistCount = () =>
  axios.get(`${API}/waitlist/count`).then((r) => r.data);

export const submitContact = (data) =>
  axios.post(`${API}/contact`, data).then((r) => r.data);

// ---- Admin / auth (cookie-based) ----
export const postSession = (session_id) =>
  axios.post(`${API}/auth/session`, { session_id }, { withCredentials: true }).then((r) => r.data);

export const getMe = () =>
  axios.get(`${API}/auth/me`, { withCredentials: true }).then((r) => r.data);

export const logout = () =>
  axios.post(`${API}/auth/logout`, {}, { withCredentials: true }).then((r) => r.data);

export const getAdminStats = () =>
  axios.get(`${API}/admin/stats`, { withCredentials: true }).then((r) => r.data);

export const getAdminWaitlist = () =>
  axios.get(`${API}/admin/waitlist`, { withCredentials: true }).then((r) => r.data);

export const getAdminContacts = () =>
  axios.get(`${API}/admin/contacts`, { withCredentials: true }).then((r) => r.data);
